import { render, staticRenderFns } from "./TabelaAvaliacoes.vue?vue&type=template&id=2fc7f65a&scoped=true"
import script from "./TabelaAvaliacoes.vue?vue&type=script&lang=ts"
export * from "./TabelaAvaliacoes.vue?vue&type=script&lang=ts"
import style0 from "./TabelaAvaliacoes.vue?vue&type=style&index=0&id=2fc7f65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7f65a",
  null
  
)

export default component.exports